import { dispatch } from '@rematch/core';
import { push } from "react-router-redux";

import { resetPasswordService, otpCheckService } from "../../services/feathers.service";
import { set } from 'lodash';

const initialState = {
  checkOtpError: false,
  resetPwdError: false,
  userEmail: null
};

export default {
  state: initialState,
  reducers: {
    setResetPwdError(state, payload) {
      return {
        ...state,
        resetPwdError: payload
      }
    },
    setUserEmail(state, payload) {
      return {
        ...state,
        userEmail: payload
      }
    },
    setCheckOtpError(state, payload) {
      return {
        ...state,
        checkOtpError: payload
      }
    },
    clear() {
      return initialState
    }

  },
  effects: {
    async resetpasswordAsync(resetDataObj) {
      try {
        await resetPasswordService.patch(resetDataObj.userid, { resetDataObj });
        dispatch.reset.setResetPwdError(false);
        return dispatch(push('/login'));
      } catch (err) {
        if(err.message == "Old password and new password cannot be same."){
          dispatch.reset.setResetPwdError("Old password and new password cannot be same");
        } else {
          dispatch.reset.setResetPwdError("Password not updated!");
        }
        throw err;
      }
    },


    async checkOtpAsync(payload) {
      try {
        let result = await otpCheckService.find({ query: payload });
        if (result.isOtpValid) {
          dispatch.reset.setCheckOtpError(false);
        }
        else {
          dispatch.reset.setCheckOtpError(true);
        }
        dispatch.reset.setUserEmail(result.email);
      } catch (err) {
        dispatch.reset.setCheckOtpError(true);
        throw err;
      }
    }

  }
}